
import { defineComponent } from "vue";
import { incomeReport } from "../components/queries";

export default defineComponent({
  name: "Queries",
  components: { incomeReport },
});
